<div style="text-align: center;background-color: blue;color: white;padding: 10px;display: flex;justify-content: space-between;align-items: center;margin: -20px -20px 20px -20px;">
    <span>{{data.title}}</span>
    <button (click)="onClose()" style="background: none;border: none;color: white;font-size: 20px;cursor: pointer;">
        <i class="fas fa-times"></i>
    </button>
</div>
<table>
    <tr>
        <th style="padding-left: 10px !important;">Lead Channel Name : </th>
        <th>
            <input type="text" [(ngModel)]="data.model.channelName" name="channelName" />
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Lead Channel Type : </th>
        <th>
            <input type="text" [(ngModel)]="data.model.channelType" name="channelType" />
        </th>
    </tr>
</table>
<br />
<button class="btn btn-sm btn-primary" (click)="onSave();" style="float: inline-end;">
    <i class="fas fa-plus"></i> Save
</button>